// src/pages/LoginPage.js
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

const LoginPage = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const { login } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);
        try {
            const userCredential = await login(email, password);
            const user = userCredential.user;

            // Fetch user data from Firestore to check their role
            const userDocRef = doc(db, 'users', user.uid);
            const userDocSnap = await getDoc(userDocRef);

            if (userDocSnap.exists()) {
                const userData = userDocSnap.data();
                // Redirect based on role
                if (userData.role === 'admin') {
                    navigate('/admin');
                } else if (userData.role === 'company') {
                    navigate('/company-dashboard');
                } else {
                    navigate('/dashboard');
                }
            } else {
                // Fallback if no user document found
                navigate('/dashboard');
            }

        } catch (err) {
            console.error("Login error:", err);
            if (['auth/user-not-found', 'auth/wrong-password', 'auth/invalid-credential'].includes(err.code)) {
                setError('Geçersiz e-posta veya şifre.');
            } else {
                setError('Giriş başarısız oldu. Lütfen tekrar deneyin.');
            }
            setLoading(false);
        }
    };

    return (
        <div className="w-full min-h-screen bg-gray-50 flex flex-col items-center justify-center py-10 px-4">
            <div className="w-full max-w-md bg-white shadow-lg rounded-lg px-8 py-8">
                <h2 className="text-2xl font-bold mb-6 text-center">Giriş Yap</h2>
                {error && <p className="bg-red-100 text-red-700 p-3 rounded mb-4 text-sm">{error}</p>}
                <form onSubmit={handleSubmit}>
                    <div className="mb-4">
                        <label className="block text-gray-700 mb-2" htmlFor="email">E-posta</label>
                        <input type="email" id="email" required className="w-full border border-gray-300 rounded px-3 py-2" value={email} onChange={(e) => setEmail(e.target.value)} />
                    </div>
                    <div className="mb-6">
                        <div className="flex justify-between items-center mb-2">
                            <label className="block text-gray-700" htmlFor="password">Şifre</label>
                            <Link to="/forgot-password" className="text-sm text-blue-500 hover:text-blue-700">
                                Şifremi Unuttum
                            </Link>
                        </div>
                        <input type="password" id="password" required className="w-full border border-gray-300 rounded px-3 py-2" value={password} onChange={(e) => setPassword(e.target.value)} />
                    </div>
                    <button type="submit" disabled={loading} className="w-full bg-black text-white py-2 rounded hover:bg-gray-800 disabled:opacity-50">
                        {loading ? 'Giriş Yapılıyor...' : 'Giriş'}
                    </button>
                </form>
                <div className="text-center text-sm text-gray-600 mt-6 space-y-2">
                    <p>
                        Henüz bir hesabınız yok mu?{' '}
                        <Link to="/register" className="text-blue-600 font-semibold hover:underline">Kayıt Ol</Link>
                    </p>
                    <p className="text-xs text-gray-500 pt-3 border-t border-gray-100">
                        Rent a car işletmesi misiniz?{' '}
                        <Link to="/register?type=company" className="text-orange-600 font-bold hover:underline">Kurumsal Kayıt Yapın</Link>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default LoginPage;